<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">{{ $t("add") }} {{ $t("ratecard") }}</div>
      <router-link class="btn-blue" to="rateCard"
        >{{ $t("ratecard") }} {{ $tc("list", 2) }}</router-link
      >
    </div>
    <div class="edit-movie-container">
      <form class="row">
        <div class="col-md-6 mb-4">
          <div class="dropdown-curve-container">
            <label :class="selectedCinema.length > 0 ? 'shift-up' : ''">{{
              $tc("cinema", 1)
            }}</label>
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :text="selectedCinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(dropdownItem, dropdownIndex) in cinemaList"
                  :key="dropdownIndex"
                  href="#"
                  @click="onDropdownChange($event, dropdownItem)"
                  >{{ dropdownItem.cine_name }}</b-dropdown-item
                >
              </b-dropdown>
              <Tooltip :title="$t('rateCard_Cinema')" />
            </div>
            <p class="error_msg">Title cannot be empty</p>
          </div>
        </div>

        <div class="col-md-6 mb-4">
          <div class="dropdown-curve-container">
            <label
              :class="selectedChargeSettingName.length > 0 ? 'shift-up' : ''"
              >{{ $tc("chargesettingname", 1) }}</label
            >
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :text="selectedChargeSettingName"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(dropdownItem, dropdownIndex) in pas_setting_name_list"
                  :key="dropdownIndex"
                  href="#"
                  @click="onChangeSettingName($event, dropdownItem)"
                  >{{ dropdownItem.pas_charge_setting_name }}</b-dropdown-item
                >
              </b-dropdown>
              <Tooltip :title="$t('rateCard_ChargeSettingName')" />
            </div>
            <p class="error_msg">Title cannot be empty</p>
          </div>
        </div>

        <!-- CINEMAS SELECTION -->
        <div class="col-md-6 mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                v-model="ratecard.rc_name"
                type="text"
                required="required"
              />
              <label>{{ $t("ratecard") }} {{ $t("name") }}</label>
            </div>
            <Tooltip :title="$t('rateCard_RateCardName')" />
          </div>
          <p class="error_message">{{ $t("blankfieldmsg") }}</p>
        </div>

        <!-- <div class="col-md-6 mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
                <input placeholder="." type="text" required="required" />
              <label>{{ $t('ratecard') }} {{ $t('description') }}</label>
            </div>
            <Tooltip :title="$t('tooltip')" />
          </div>
          <p class="error_message">{{ $t('blankfieldmsg') }}</p>
        </div>-->

        <div class="col-md-6 mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                v-model="ratecard.rc_amount"
                v-on:keyup="onChangeRatecardAmount($event)"
                type="text"
                required="required"
              />
              <label>{{ $t("amount") }}</label>
            </div>
            <Tooltip :title="$t('rateCard_Amount')" />
          </div>
          <p class="error_message">{{ $t("blankfieldmsg") }}</p>
        </div>

        <div class="col-md-6 mb-4">
          <div class="d-flex align-items-center pt-3">
            <div class="mr-2">
              <label>{{ $t("inclusivoftax") }}</label>
            </div>
            <div class>
              <div>
                <b-form-checkbox
                  unchecked-value="N"
                  value="Y"
                  v-model="ratecard.rc_is_active_inclusivtax"
                  name="check-button"
                  @change="OnSwitchHandler($event)"
                  switch
                ></b-form-checkbox>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-12">
          <div>
            <div class="font-weight-bold mb-2">
              {{ $t("add") }} {{ $tc("charge", 2) }}
            </div>
          </div>

          <div
            class="col-12"
            v-for="(cinemaCharge, cinemaChargesListIndex) in list"
            :key="cinemaChargesListIndex"
          >
            <div class="row">
              <!-- IMAGE DIMENSION -->
              <div class="col-md-5 mb-4">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <!-- <input v-model="cinemaCharge.rc_name" type="text" required="required" /> -->
                    <label>{{ cinemaCharge.ct_name }}</label>
                  </div>
                </div>
                <p class="error_msg">Invalid Entry</p>
              </div>
              <div class="col-md-7">
                <div class="row">
                  <div class="col-md-5">
                    <div
                      class="
                        d-flex
                        justify-content-center
                        align-items-center
                        p-3
                      "
                    >
                      <label
                        >{{ cinemaCharge.pas_charge_value
                        }}{{
                          cinemaCharge.pas_is_percentage == "Y" ? "%" : ""
                        }}</label
                      >
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div
                      class="
                        d-flex
                        justify-content-center
                        align-items-center
                        p-3
                      "
                    >
                      <label>{{ cinemaCharge.cinemacharges.toFixed(4) }}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="text-right">
              <div>
                <span class="font-weight-bold">Net Amount:</span>
                <span
                  >{{ currencyData.curr_code }}
                  {{ ratecard.rc_net_amount.toFixed(MIN_FRACTION_DIGITS) }}</span
                >
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="text-right">
              <div>
                <span class="font-weight-bold">Gross Total:</span>
                <span
                  >{{ currencyData.curr_code }}
                  {{ ratecard.rc_total_amount.toFixed(MIN_FRACTION_DIGITS) }}</span
                >
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button @click.prevent.stop="onRouterBack()" class="btn-blue">
            {{ $t("back") }}
          </button>
          <button @click.prevent.stop="OnFinalSubmit()" class="btn-blue">
            {{ $t("next") }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import CinemasService from "@/services/CinemasService";

export default {
  data() {
    return {
      // Saif
      cinemaList: [],
      currencyData: [],
      selectedCinema: "",
      cinemaChargesList: [],
      selectedChargeSettingName: "Select Charge Settings",
      pas_setting_name_list: [],
      ratecard: {
        cinema_id: null,
        rc_name: "",
        rc_amount: 0,
        currency_id: null,
        rc_is_active_inclusivtax: "Y",
        rc_net_amount: 0,
        rc_total_amount: 0,
      },
      // Saif
    };
  },
  beforeMount() {
    this.getGlobalOptions();
    this.getCinemaList();
    this.getCurrencyCode();
  },
  mounted() {},
  computed: {
    list() {
      return this.cinemaChargesList;
    },
  },
  methods: {
    onRouterBack: function () {
      this.$router.push({
        path: "charge-settings",
      });
    },
    getCurrencyCode: function () {
      let payload = {
        tableName: "ms_currencies",
        curr_is_active: "Y",
        curr_id:
          this.secureStore.get("BRGLOPCU") &&
          this.secureStore.get("BRGLOPCU").go_value,
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.currencyData = data.Records[0];
          } else {
            // Show Error Message:
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          // Catch Error:
          console.log("Catch Error on getActiveScreenByCinemaId :", error);
        });
    },
    // Saif
    resetForm: function () {
      this.selectedCinema = "Selected Cinema";
      this.ratecard = {
        cinema_id: null,
        rc_name: "",
        rc_amount: 0,
        currency_id: null,
        rc_is_active_inclusivtax: "Y",
        rc_net_amount: 0,
        rc_total_amount: 0,
      };
      this.cinemaChargesList = [];
    },
    getGlobalOptions: function () {
      MasterService.GetGlobalOptions()
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            data.Records.map((x) => {
              if (x.go_key === "CURRENCY") {
                this.ratecard.currency_id = x.go_value || null;
              }
            });
          } else {
            // Show Error
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          //Catch Error
          console.log("catch error on GetGlobalOptions :", error);
        });
    },
    getCinemaList: function () {
      let body = this.getRequestBody("GET", undefined, {
        GET: "/admin/",
        tableName: "ms_cinemas",
      });
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.cinemaList = data.Records;
          } else {
            console.log("show error1 :", data.message);
          }
        })
        .catch((error) => {
          console.log("show error2 :", error);
        });
    },
    getCinemaCharges: function (id) {
      this.cinemaChargesList = [];
      let payload = {
        pas_charge_setting_name: this.selectedChargeSettingName,
        id: id,
      };
      CinemasService.GetCinemaChargesByCinemaId(payload)
        .then(async (response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.cinemaChargesList = data.Records;
            let promises = this.cinemaChargesList.map((x) => {
              x["cinemacharges"] = 0;
              return x;
            });
            await Promise.all(promises).then(() => {
              this.cinemaChargesCalculation();
            });
          } else {
            // Show Error Message Here
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          // Show Catch Error
          console.log("catch error on GetCinemaCharges :", error);
        });
    },
    // On click and Change Handler
    onDropdownChange: function (event, item) {
      this.selectedCinema = item.cine_name;
      this.ratecard.cinema_id = item.cine_id;
      // this.getCinemaCharges(item.cine_id);
      this.getPasSettingName(item.cine_id);
    },
    getPasSettingName: function (id) {
      this.pas_setting_name_list = [];
      CinemasService.GetCinemaSettingNameByCinemaId({ id })
        .then(async (response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.pas_setting_name_list = data.Records;
          } else {
            // Show Error Message Here
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          // Show Catch Error
          console.log("catch error on GetCinemaCharges :", error);
        });
    },
    onChangeSettingName: function (event, item) {
      this.selectedChargeSettingName = item.pas_charge_setting_name;
      this.getCinemaCharges(this.ratecard.cinema_id);
    },
    OnSwitchHandler: function (event) {
      this.ratecard.rc_is_active_inclusivtax = event;
      this.cinemaChargesCalculation();
    },
    onChangeRatecardAmount: function (event) {
      this.cinemaChargesCalculation();
    },
    cinemaChargesCalculation: function () {
      this.ratecard.rc_net_amount = parseFloat(this.ratecard.rc_amount);
      this.ratecard.rc_total_amount = parseFloat(this.ratecard.rc_amount);

      this.cinemaChargesList.map((x) => {
        if (this.ratecard.rc_is_active_inclusivtax === "N") {
          if (x.pas_is_percentage === "Y") {
            x.cinemacharges =
              (parseFloat(this.ratecard.rc_amount) *
                parseFloat(x.pas_charge_value)) /
              100;
          }
          this.calculateNetAmount(x, "Plus");
          // this.ratecard.rc_net_amount += parseFloat(x.cinemacharges);
        } else if (this.ratecard.rc_is_active_inclusivtax === "Y") {
          if (x.pas_is_percentage === "Y") {
            x.cinemacharges =
              ((parseFloat(this.ratecard.rc_amount) /
                this.calculatePercentageCharge()) *
                parseFloat(x.pas_charge_value)) /
              100;
          }
          this.calculateNetAmount(x, "Minus");
        }
        if (x.pas_is_percentage === "N" && x.pas_is_taxable === "Y") {
          x.cinemacharges =
            parseFloat(x.pas_charge_value) * this.calculateTaxableCharge();
        } else if (x.pas_is_percentage === "N" && x.pas_is_taxable === "N") {
          x.cinemacharges = parseFloat(x.pas_charge_value);
        }
        return x;
      });
      this.$forceUpdate();
    },
    calculatePercentageCharge: function () {
      let finalvalue = 1;
      this.cinemaChargesList.map((x) => {
        if (x.pas_is_percentage === "Y") {
          finalvalue += parseFloat(x.pas_charge_value) / 100;
        }
      });
      return finalvalue;
    },
    calculateNetAmount: function (x, equation) {
      if (equation === "Plus") {
        if (x.pas_is_percentage === "Y") {
          this.ratecard.rc_total_amount += parseFloat(x.cinemacharges);
        } else if (x.pas_is_percentage === "N" && x.pas_is_taxable === "N") {
          this.ratecard.rc_total_amount += parseFloat(x.pas_charge_value);
        }
      } else if (equation === "Minus") {
        if (x.pas_is_percentage === "Y") {
          this.ratecard.rc_net_amount -= parseFloat(x.cinemacharges);
        } else if (x.pas_is_percentage === "N" && x.pas_is_taxable === "N") {
          this.ratecard.rc_net_amount -= parseFloat(x.pas_charge_value);
        }
      }
    },
    calculateTaxableCharge: function () {
      let finalvalue = 1;
      this.cinemaChargesList.map((x) => {
        if (x.pas_is_percentage === "Y") {
          finalvalue -= parseFloat(x.pas_charge_value) / 100;
        }
      });
      return finalvalue;
    },
    __cinemaChargesCalculation: function () {
      this.ratecard.rc_net_amount = parseFloat(this.ratecard.rc_amount);
      this.cinemaChargesList.map((x) => {
        if (this.ratecard.rc_is_active_inclusivtax === "N") {
          if (x.pas_is_percentage === "Y") {
            x.cinemacharges =
              (parseFloat(this.ratecard.rc_amount) *
                parseFloat(x.pas_charge_value)) /
              100;
          } else if (x.pas_is_percentage !== "Y") {
            x.cinemacharges = x.pas_charge_value;
          }
          this.ratecard.rc_net_amount += parseFloat(x.cinemacharges);
        } else if (this.ratecard.rc_is_active_inclusivtax === "Y") {
          if (x.pas_is_percentage === "Y") {
            x.cinemacharges =
              (parseFloat(this.ratecard.rc_amount) *
                parseFloat(x.pas_charge_value)) /
              100;
          } else if (x.pas_is_percentage !== "Y") {
            x.cinemacharges = x.pas_charge_value;
          }
        }
        return x;
      });
      this.$forceUpdate();
    },
    OnFinalSubmit: function () {
      let payload = {
        ...this.ratecard,
        rc_amount: parseFloat(this.ratecard.rc_amount),
        rc_net_amount: parseFloat(this.ratecard.rc_net_amount),
        rc_pas_setting_name: this.selectedChargeSettingName,
        cinemaChargesList: this.cinemaChargesList,
      };
      CinemasService.AddRatecard(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            this.resetForm();
            this.$router.push({
              path: "cinema-concession-levels",
            });
          } else {
            // Show Error Message
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          // Catch Error:
          console.log("catch error on OnFinalSubmit :", error);
        });
    },
    // Saif
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Installation/priceMaster.vue